import DayjsExtended from "@logic/DayjsExtended";
import type { Dayjs } from "dayjs";

export type ContentCalendarWeekRange = [Date, Date];

function getMonday(date: Dayjs): Dayjs {
  return date.subtract((date.day() + 6) % 7, "day").startOf("day");
}

export function createContentCalendarWeekRange(weekGroup?: string | null): ContentCalendarWeekRange {
  const requestedDate = weekGroup ? DayjsExtended(weekGroup) : DayjsExtended().add(1, "week");
  const monday = getMonday(requestedDate.isValid() ? requestedDate : DayjsExtended().add(1, "week"));
  return [monday.subtract(1, "day").toDate(), monday.add(5, "day").toDate()];
}

export function getContentCalendarWeekKey(range: ContentCalendarWeekRange | null): string {
  // Server week keys start on Monday, while the user-facing picker displays Sunday through Saturday.
  const selectedStart = range?.[0];
  const sunday = selectedStart ? DayjsExtended(selectedStart).startOf("day") : getMonday(DayjsExtended().add(1, "week")).subtract(1, "day");
  return sunday.add(1, "day").format("YYYY-MM-DD");
}

export function formatContentCalendarWeekRange(range: ContentCalendarWeekRange | null, options?: { startOnly?: boolean }): string {
  const resolvedRange = range ?? createContentCalendarWeekRange();
  const start = DayjsExtended(resolvedRange[0]);
  if (options?.startOnly) {
    return start.format("MMM Do");
  }
  const end = DayjsExtended(resolvedRange[1]);
  if (start.month() !== end.month()) {
    return `${start.format("MMM D")}–${end.format("MMM D")}`;
  }
  return `${start.format("MMM D")}–${end.format("D")}`;
}
